
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.096 16.255L10 17.213l-1.096-.958C4.988 12.837 3 9.811 3 7c0-3.979 3.103-7 7-7 3.896 0 7 3.021 7 7 0 2.811-1.988 5.837-5.904 9.255zm-7.41-3.452c.41.563.868 1.134 1.371 1.716C3.195 14.939 2 15.534 2 16c0 .807 3.58 2 8 2s8-1.193 8-2c0-.466-1.195-1.062-3.057-1.481a26.43 26.43 0 001.371-1.716C18.564 13.486 20 14.58 20 16c0 2.507-4.48 4-10 4S0 18.507 0 16c0-1.42 1.437-2.514 3.686-3.197zM10 2c2.804 0 5 2.138 5 5 0 2.047-1.627 4.566-5 7.556C6.627 11.566 5 9.047 5 7c0-2.862 2.196-5 5-5zm0 2a3 3 0 110 6 3 3 0 010-6zM9 7a1 1 0 112 0 1 1 0 01-2 0z"}})])
          )
        }
      }
    